import { Component, Input, forwardRef, Injector, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';

@Component({
  selector: 'app-input-checkbox',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './input-checkbox.component.html',
  styleUrls: ['./input-checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputCheckboxComponent),
      multi: true
    }
  ]
})
export class InputCheckboxComponent implements ControlValueAccessor, OnInit {
  @Input() label: string = '';
  @Input() errorMessage: string = '';
  @Input() disabled: boolean = false;
  @Input() id: string = `checkbox-${Math.random().toString(36).substring(2, 9)}`;
  @Input() name: string = '';
  
  private _checked: boolean = false;
  private _touched: boolean = false;
  private control: NgControl | null = null;
  
  @Input()
  get checked(): boolean {
    return this._checked;
  }
  
  set checked(val: boolean) {
    this._checked = val;
    this.onChange(val);
  }
  
  onChange: any = () => {};
  onTouched: any = () => {};

  constructor(private injector: Injector) {}

  ngOnInit(): void {
    // Get reference to the NgControl (FormControl)
    this.control = this.injector.get(NgControl, null);
  }

  writeValue(value: boolean): void {
    this._checked = value || false;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  toggleCheckbox() {
    if (!this.disabled) {
      this.checked = !this.checked;
      this.markAsTouched();
    }
  }
  
  markAsTouched() {
    if (!this._touched) {
      this._touched = true;
      this.onTouched();
    }
  }
  
  // Computed property to check if the checkbox has errors
  get hasError(): boolean {
    // Check both internal touched state and form control touched state
    const isTouched = this._touched || (this.control?.touched ?? false);
    return this.errorMessage !== '' && isTouched;
  }

  // Computed property to get the error message
  get errorMsg(): string {
    return this.hasError ? this.errorMessage : '';
  }
}
